module.exports = __webpack_public_path__ + "img/013-border-2-a.0b6f97f9.png";